import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";

const DeleteConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  plantName,
  loading,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          p: 1,
        },
      }}
    >
      <DialogTitle sx={{ bgcolor: "#f5f5f5", py: 2 }}>
        <Typography variant="h6" fontWeight={600}>
          Confirm Delete
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to delete the plant "
          <strong>{plantName || "this plant"}</strong>"?
        </Typography>
        <Typography variant="body2" color="error" sx={{ mt: 2 }}>
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2, bgcolor: "#f5f5f5" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderColor: "#e57373",
            color: "#e57373",
            "&:hover": {
              borderColor: "#c62828",
              bgcolor: "rgba(229, 115, 115, 0.08)",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : <DeleteIcon />}
          sx={{ bgcolor: "#e57373", "&:hover": { bgcolor: "#c62828" } }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
